import React from 'react';
import NewsletterOnboarding from './NewsletterOnboarding';
import { User } from '../types/User';

interface OnboardingFlowProps {
    user: User;
    onFinish: () => void | Promise<void>;
}

// Thin wrapper around NewsletterOnboarding so App.tsx has a stable
// "/onboarding" entry point regardless of what onboarding actually looks
// like. (Previously this also branched on account type into a separate
// company-onboarding flow feeding the sponsor board; both were removed —
// see git history if that's ever wanted back.)
const OnboardingFlow: React.FC<OnboardingFlowProps> = ({ user, onFinish }) => (
    <NewsletterOnboarding
        onComplete={() => onFinish()}
        onSkip={() => onFinish()}
        existingData={user.newsletterInfo || undefined}
    />
);

export default OnboardingFlow;
